var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "jcb_svg__ic_jcb",
    viewBox: "0 0 33 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".jcb_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jcb_svg__Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_67",
    d: "M29.92 0H3.08A3.025 3.025 0 0 0 0 3.017v15.966A3.06 3.06 0 0 0 3.08 22h26.84A3.025 3.025 0 0 0 33 18.983V3.017A3.025 3.025 0 0 0 29.92 0z",
    className: "jcb_svg__cls-1",
    "data-name": "Path 67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_68",
    d: "M29.92 1.1a1.924 1.924 0 0 1 1.98 1.92v15.963a1.958 1.958 0 0 1-1.98 1.92H3.08a1.924 1.924 0 0 1-1.98-1.92V3.017A1.924 1.924 0 0 1 3.08 1.1h26.84m0-1.1H3.08A3.025 3.025 0 0 0 0 3.017v15.966A3.06 3.06 0 0 0 3.08 22h26.84A3.025 3.025 0 0 0 33 18.983V3.017A3.025 3.025 0 0 0 29.92 0z",
    "data-name": "Path 68",
    fill: "#f2f2f2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "jcb_svg__Group_67",
    "data-name": "Group 67",
    transform: "translate(8.91 3.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jcb_svg__Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_69",
    d: "M39.92 14.58c.055 1.54.11 3.19.055 4.785a2.011 2.011 0 0 1-1.045 1.6 2.885 2.885 0 0 1-1.54.33l-2.09-.055V7.98a2.253 2.253 0 0 1 1.6-1.87c.985-.11 1.92-.055 3.02-.11l.055.66v7.59l-.055.055z",
    "data-name": "Path 69",
    transform: "translate(-24.795 -5.959)",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_70",
    d: "M16.255 14.051v-6.27a2.447 2.447 0 0 1 1.375-1.65 10.739 10.739 0 0 1 3.245-.165c.055 1.045 0 2.31.055 3.19l.055 8.195c-.165 1.265.33 2.97-1.265 3.685-.99.5-2.31.165-3.465.275l-.055-.165v-6.82l.055-.275z",
    "data-name": "Path 70",
    transform: "translate(-16.2 -5.925)",
    fill: "#0071bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_71",
    d: "M16.3 19.355a2.4 2.4 0 0 0 1.7.99c.825.055 1.98.165 2.585-.66.385-.44.165-.99.275-1.54l-.055-.99a13.415 13.415 0 0 0-1.54-.055c-.275 1.045.44 2.255-.77 2.805a1.287 1.287 0 0 1-.99-.165c-.44-.11-.22-.825-.825-.66l-.33-.055-.055.33z",
    className: "jcb_svg__cls-1",
    "data-name": "Path 71",
    transform: "translate(-16.245 -10.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_72",
    d: "m30.42 6.88.055 12.76a2.22 2.22 0 0 1-1.32 1.485 11.012 11.012 0 0 1-3.3.165L25.8 7.87a2.007 2.007 0 0 1 1.045-1.54A2.679 2.679 0 0 1 28.22 6h2.255z",
    "data-name": "Path 72",
    transform: "translate(-20.52 -5.959)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_73",
    d: "M30.333 17.155c.055.165 0 .275.055.44a2.636 2.636 0 0 0-2.475.165 1.3 1.3 0 0 0 .44 2.145 3.25 3.25 0 0 0 2.035-.165.6.6 0 0 1 0 .44h-3.025a1.442 1.442 0 0 1-1.155-.935 1.555 1.555 0 0 1 .275-1.6 1.79 1.79 0 0 1 1.265-.55z",
    className: "jcb_svg__cls-1",
    "data-name": "Path 73",
    transform: "translate(-20.653 -10.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jcb_svg__Path_74",
    d: "M40.044 19.551a.82.82 0 0 1-.66.66h-3.63l-.165-.055a28.782 28.782 0 0 1 .055-3.08h2.31c.77.055 1.54-.275 1.87.44a.773.773 0 0 1-.11.77c-.11.165-.33.22-.385.33a1.116 1.116 0 0 1 .715.6zm-3.19-2.145a5.656 5.656 0 0 0-.055.99c.55-.055 1.265.165 1.65-.275a.417.417 0 0 0-.055-.55c-.33-.271-.994-.055-1.54-.165zm1.43 1.485a12.916 12.916 0 0 0-1.43-.055 3.255 3.255 0 0 0 .055 1.045 3.507 3.507 0 0 0 1.54-.165.528.528 0 0 0 .165-.55c0-.11-.165-.22-.33-.275z",
    className: "jcb_svg__cls-1",
    "data-name": "Path 74",
    transform: "translate(-24.919 -10.93)"
  })))));
};
export default SvgJcb;